import { render } from "./Tm_header.vue?vue&type=template&id=9aab8fda&scoped=true&ts=true"
import script from "./Tm_header.vue?vue&type=script&lang=ts"
export * from "./Tm_header.vue?vue&type=script&lang=ts"

import "./Tm_header.vue?vue&type=style&index=0&id=9aab8fda&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1530414395/src/mediadept-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9aab8fda"]])

export default __exports__